import { videoKey } from './parseVideoLink';

interface SubmissionLike {
  platform: string;
  url: string;
  disqualified?: boolean;
}

/**
 * Client-side tier-1 dedupe: match by canonical video key when parseable,
 * by exact raw URL otherwise. Short links that need network resolution are
 * left to the backend's async tier.
 */
export function findDuplicateSubmission<T extends SubmissionLike>(
  { url, submissions }: { url: string; submissions: T[] },
): T | null {
  const active = submissions.filter((s) => !s.disqualified);
  const candidateKey = videoKey(url);
  if (candidateKey) {
    return active.find((s) => videoKey(s.url) === candidateKey) ?? null;
  }
  const trimmed = url.trim();
  return active.find((s) => s.url.trim() === trimmed) ?? null;
}
